
//Removes production build tip for Vue
Vue.config.productionTip = false;

(function() {

    window.addEventListener("beforeunload", function (event) {
        document.body.classList.add('loading');
    });

    document.addEventListener('DOMContentLoaded', function(e) {
        document.body.classList.remove('loading');
    });

    document.addEventListener('visibilitychange', function(e) {
        if (document.visibilityState === 'visible') {
            document.body.classList.remove('loading');
        }
    });

    setTimeout(function() {
        $('[data-init-loading]').removeAttr('data-init-loading');
    }, 100);

    $.fn.tooltip.Constructor.Default.boundary = "window";

    // Bootstrap bindings
    $('[data-toggle="tooltip"]').tooltip()

    //fix for lack of window.origin in IE
    if (!window.location.origin) {
        window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
    }
})();


//Checks that forms are filled out before being able to sumbit request quote page
(function() {
    $('.quote-form-control').keyup(function() {
        var empty = false;
        $('.quote-form-control').each(function() {
            if ($(this).val() == '') {
                empty = true;
            }
        });

        if (empty) {
            $('#request-quote-submit').attr('disabled', 'disabled');
        } else {
            $('#request-quote-submit').removeAttr('disabled');
        }
    });
})()



// CSRF (XSRF) security
function addAntiForgeryToken(data) {
    //if the object is undefined, create a new one.
    if (!data) {
        data = {};
    }
    //add token
    var tokenInput = $('input[name=__RequestVerificationToken]');
    if (tokenInput.length) {
        data.__RequestVerificationToken = tokenInput.val();
    }
    return data;
};